export { default as Switch } from './Switch';
export * from './types';
